
//CONTROL PAGE LOADING
var pageLoader = function(){
    var passiveSupported = false;

    try {
        const options = {
            get passive() { // This function will be called when the browser
                //   attempts to access the passive property.
                passiveSupported = true;
                return false;
            }
        };

        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    } catch(err) {
        passiveSupported = false;
    }

    //Vars
    var _queue = [],
        _lazyLoader,
        _allItems,
        _time = 25,
        _lazyClass = 'loader-trigger',
        _readyClass = 'loader-ready',
        _inClass = 'loader-in';



    /**
     * Start Laziness.
     */
    var _init = function(){
        window.removeEventListener("resize", _onScrollEvent);
        window.removeEventListener("scroll", _onScrollEvent);
        window.addEventListener("resize", _onScrollEvent, passiveSupported ? { passive: true } : false);
        window.addEventListener("scroll", _onScrollEvent, passiveSupported ? { passive: true } : false);
		_allItems = $("." + _lazyClass);
        _onScrollEvent();
        _startTimer();
    };




    /**
     * loop though .lazy elements and if they are in the viewport, add them to the queue.
     */
    var _onScrollEvent = function(){
        $("." + _lazyClass).each(function() {
            //ABORT IF ALREADY QUEUED
            if($(this).hasClass(_readyClass)){ return true; }
            //IF ELM IS IN VIEWPORT
            if (_isInViewport(this)) {
                $(this).addClass(_readyClass);
                _queueElm(this);
            }
        });
    };




    /**
     * Detect if element is in viewport
     */
    var _isInViewport = function(elm) {
        var elementTop = $(elm).offset().top;
        var elementBottom = elementTop + $(elm).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };




    /**
     * Add individual elements to the end of the queue
     */
    var _queueElm = function(el){
        _queue.push(el);
    };




    /**
     * Adjust Timer
     */
    var _setTime = function(int){
        _time = parseInt(int);
    };




    /**
     * Change Class
     */
    var _setLazyClass = function(str){
        _lazyClass = parseInt(str);
    };




    /**
     * Empty the queue
     */
    var _clearQueue = function(){
        _queue = [];
    };




    /**
     * Unset the timer
     */
    var _clearTimer = function(){
        clearInterval(_lazyLoader);
    };




    /**
     * Start the perpetual checking of the queue.
     */
    var _startTimer = function(){
        //START TIMER
        _lazyLoader = setInterval(function(){
            //DO NOTHING IF QUEUE IS EMPTY
            if(_queue.length === 0) { return true; }
            var theItem = $(_queue[0]);
            //ADD CLASS AND REMOVE FROM QUEUE
            theItem.addClass(_inClass);
            theItem.trigger('cssClassChanged');

            _queue.shift();

        },_time);
    };




    //DO INIT
    _init();



    /**
     * Public Methods
     */

    return {
        init:_init,
         onScrollEvent:_onScrollEvent,
    };
}();